import { Component, Input, Output, EventEmitter, OnInit } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { LanguageService } from '../../services/language.service';

interface Language {
    code: string;
    name: string;
    nativeName: string;
}

@Component({
    selector: 'app-language-selector',
    templateUrl: './language-selector.component.html',
    styleUrls: ['./language-selector.component.css']
})
export class LanguageSelectorComponent implements OnInit {
    @Input() visible = false;
    @Output() visibleChange = new EventEmitter<boolean>();

    languages: Language[] = [
        { code: 'zh-CN', name: '简体中文', nativeName: '简体中文' },
        { code: 'zh-TW', name: '繁體中文', nativeName: '繁體中文' },
        { code: 'en-US', name: 'English', nativeName: 'English' },
        { code: 'ru-RU', name: 'Русский', nativeName: 'Русский' }
    ];

    currentLang: string = '';

    constructor(
        private translate: TranslateService,
        private languageService: LanguageService
    ) { }

    ngOnInit() {
        const savedLang = localStorage.getItem('selectedLanguage');
        if (savedLang) {
            this.currentLang = savedLang;
            this.translate.use(savedLang);
        }
    }

    changeLanguage(langCode: string): void {
        this.languageService.changeLanguage(langCode);
        this.currentLang = langCode;
        this.close();
    }

    close(): void {
        this.visible = false;
        this.visibleChange.emit(false);
    }
}